/**
 * Breakpoints.js
 * version 1.0
 *
 * Creates handy events for your responsive design breakpoints
 * Copyright 2011 XOXCO, Inc
 * http://xoxco.com/
 *
 * Documentation for this plugin lives here:
 * http://xoxco.com/projects/code/breakpoints
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

import $ from 'jquery';
import signals from 'signals';

let lastSize = 0;
let options = null;
let interval = null;
const sizes = {
  320: 'phone',
  420: 'mobile',
  768: 'small',
  992: 'medium',
  1200: 'large',
};

const changed = new signals.Signal();

const BreakPoint = {
  bind(fn) {
    changed.add(fn);
  },

  bindOnce(fn) {
    changed.addOnce(fn);
  },

  unbind(fn) {
    changed.remove(fn);
  },

  unbindAll(_fn) {
    changed.removeAll();
  },

  updateFunction(_e) {
    if (typeof window === 'undefined') {
      return;
    }
    const w = $(window).width();
    let done = false;
    let exitingBreakpoint = null;
    let enteringBreakpoint = null;

    for (const bp in options.breakpoints.sort(function (a, b) {
      return b - a;
    })) {
      // When the browser expands to a larger breakpoint. Also removes other breakpoints.
      if (
        !done &&
        w >= options.breakpoints[bp] &&
        lastSize < options.breakpoints[bp]
      ) {
        for (const x in options.breakpoints.sort(function (a, b) {
          return b - a;
        })) {
          if (
            $('body').hasClass(`breakpoint-${sizes[options.breakpoints[x]]}`)
          ) {
            $('body').removeClass(
              `breakpoint-${sizes[options.breakpoints[x]]}`
            );
          }
        }

        const tmpIndex =
          options.breakpoints.indexOf(options.breakpoints[bp]) + 1;
        enteringBreakpoint = options.breakpoints[bp];
        exitingBreakpoint = options.breakpoints[tmpIndex];

        $('body').addClass(`breakpoint-${sizes[enteringBreakpoint]}`);

        changed.dispatch(sizes[enteringBreakpoint], sizes[exitingBreakpoint]);

        done = true;
      }

      // When the browser contracts to a smaller breakpoint.
      if (w < options.breakpoints[bp] && lastSize >= options.breakpoints[bp]) {
        const tmpIndex =
          options.breakpoints.indexOf(options.breakpoints[bp]) + 1;
        enteringBreakpoint = options.breakpoints[tmpIndex];
        exitingBreakpoint = options.breakpoints[bp];

        changed.dispatch(sizes[enteringBreakpoint], sizes[exitingBreakpoint]);

        $('body').removeClass(`breakpoint-${sizes[exitingBreakpoint]}`);
        $('body').addClass(`breakpoint-${sizes[enteringBreakpoint]}`);
      }
    }

    // set up for next call
    if (lastSize !== w) {
      lastSize = w;
      exitingBreakpoint = null;
      enteringBreakpoint = null;
    }
  },
};

(function ($) {
  $.fn.resetBreakpoints = function () {
    if (interval) {
      clearInterval(interval);
    }

    lastSize = 0;
  };

  $.fn.setBreakpoints = function (settings) {
    if (typeof window === 'undefined') {
      return;
    }
    options = $.extend(
      {
        breakpoints: new Array(320, 420, 768, 992, 1200),
      },
      settings
    );

    interval = setInterval(function () {
      BreakPoint.updateFunction();
    }, 250);
  };
})($);

$(document).ready(function () {
  if (typeof window !== 'undefined') {
    $(window).setBreakpoints();
  }
});

export default BreakPoint;
